import { lazy } from "react";

const UserProfile = lazy(() => import("pages/UserProfile"));

const GeneralSettingsPage = lazy(() =>
  import("pages/settings/GeneralSettingsPage")
);
const SettingsPage = lazy(() => import("pages/settings/SettingsPage"));

export default [
  {
    path: "profile",
    element: <UserProfile />,
  },
  //
  // Settings
  {
    path: "settings",
    element: <SettingsPage />,
    children: [
      {
        path: "general",
        element: <GeneralSettingsPage />,
      },
    ],
  },
];
